"use client";
import { ReactNode } from "react";
import { useTranslations } from "next-intl";
import { Info } from "lucide-react";
import { useTenant } from "@/app/hooks";

export const InputNotice = () => {
   const translation = useTranslations("Auth.login");
   const tenant = useTenant();

   return (
      <div
         className="flex text-xs text-muted-foreground"
         role="note"
         aria-label="login-notice"
      >
         <Info
            className="mr-1 mt-0.5 h-4 w-4 shrink-0 text-blue-500"
            aria-hidden="true"
         />
         <p className="leading-5 break-words text-pretty">
            {translation.rich("loginNotice", {
               tenantName: tenant?.rootDomain.toLocaleUpperCase() || "",
               link: (chunks: ReactNode) => <b>{chunks}</b>
            })}
         </p>
      </div>
   );
};
